import { Injectable, NgZone } from '@angular/core'
import { noop, Observable } from 'rxjs'
import { captureException } from '@sentry/angular-ivy'
import { appConfig } from '../../../brands/_current/config/app-config'
import { Router } from '@angular/router'
import { selectUseTestRecaptcha } from '../app-config/store/selectors/initial-config.selectors'
import { map, take } from 'rxjs/operators'
import { Store } from '@ngrx/store'

@Injectable({
  providedIn: 'root',
})
export class RecaptchaService {
  /**
   * Creates an instance of RecaptchaService.
   * @param zone Angular NgZone service.
   * @param router Angular Router service.
   * @param store NgRx Store for application state.
   */
  constructor(
    private readonly zone: NgZone,
    private readonly router: Router,
    private readonly store: Store,
  ) {}

  /**
   * Executes the reCAPTCHA challenge for the given widget ID.
   * @param recaptchaId The ID of the reCAPTCHA widget to execute.
   */
  public execute(recaptchaId: number) {
    grecaptcha.execute(recaptchaId).then(noop)
  }

  /**
   * Resets the reCAPTCHA widget for the given ID.
   * @param recaptchaId The ID of the reCAPTCHA widget to reset.
   */
  public reset(recaptchaId: number) {
    grecaptcha.reset(recaptchaId)
  }

  /**
   * Handles errors that occur during reCAPTCHA solving and reports them to Sentry.
   */
  public handleRecaptchaError() {
    const error = new Error('Recaptcha cannot be solved')
    console.error(error)
    captureException(error)

    // this.zone
    //   .run(() => this.router.navigate(['/', appConfig.feedback.paths._root, appConfig.feedback.paths.networkError]))
    //   .then(noop)
  }

  /**
   * Returns the correct reCAPTCHA site key based on the application configuration.
   */
  public getRecaptchaKey(): Observable<string> {
    return this.store.select(selectUseTestRecaptcha).pipe(
      take(1),
      map((test) => (test ? appConfig.core.recaptcha.testSiteKey : appConfig.core.recaptcha.siteKey)),
    )
  }
}
